import { FC } from 'react';

import { SettingsPageMetadata } from '@/shared';

interface Props {
    name: string;
}

const Metadata: FC<Props> = ({ name }) => (
    <SettingsPageMetadata scope='Workspace' segments={[name || 'Loading Team…', 'Teams', 'Permissions']} />
);

export default Metadata;
